module.exports = __webpack_public_path__ + "img/active-layer2.db4a9d8a.png";